import { FC, PropsWithChildren, Suspense } from 'react';
import { LoadingOverlay, theme } from '@csp/csp-web-ui';

export const SuspenseLoader: FC<PropsWithChildren> = ({ children }) => (
  <Suspense fallback={<LoadingOverlay isLoading bgcolor={theme.palette.transparent.default} />}>{children}</Suspense>
);
